/* eslint-disable no-param-reassign */
export default {
  namespaced: true,
  state: {
    promoCodes: [],
  },

  getters: {
    getPromoCodes(state) {
      return state.promoCodes;
    },
    hasAutoshipPromotion(state, getters) {
      return getters.getPromoCodes.some((promo) => promo.code.startsWith('FREEWITHAUTOSHIP-'));
    },
  },

  actions: {
    async fetchPromoCodes({ commit }) {
      try {
        const response = await this.$app.$api.get('v1/cx/promo-codes');

        commit('setPromoCodes', response.data.data);
      } catch {
        // consume
      }
    },
    async setupPromoCodes({ dispatch, commit, getters }) {
      if (sessionStorage.getItem('promoCodes')) {
        commit('setPromoCodes', JSON.parse(sessionStorage.getItem('promoCodes')));
      } else {
        await dispatch('fetchPromoCodes');
        sessionStorage.setItem('promoCodes', JSON.stringify(getters.getPromoCodes));
      }
    },
  },

  mutations: {
    setPromoCodes(state, data) {
      state.promoCodes = data;
    },
  },
};
